import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { errorMessage } from '../../constants/errorMessage'
import './qrScanCss.scss'
import CommonQr from './CommonQr'
import { useParams } from 'react-router-dom'
import { isValidPromoCode } from '../../utils/helper'

// PROMOCODE SCANNING QR
function ScanPromoQr(props) {
    const { notify, setIsScanDisplay, setScanResult, scanResult, handleValidateTicket  } = props
    const [isDataRecorded, setIsDataRecorded] = useState(false)
    const {ticketId} = useParams()
    useEffect(() => {
        const handlePopState = () => {
            window.history.pushState(null, document.title, window.location.href)
            setIsScanDisplay(false)
        }

        window.history.pushState(null, document.title, window.location.href)
        window.addEventListener('popstate', handlePopState)

        return () => {
            window.removeEventListener('popstate', handlePopState)
        }
    }, [])

    useEffect(() => {
        if (scanResult && scanResult != null) {
            //    Action for Scann

        }
    }, [scanResult])

    const handleScan = (data) => {

        if (data?.text) {
            if (!isDataRecorded) {
                //Redirect
                // console.log(data?.text)
                // const facilityData = data?.text.split('https://demo-transient.parkengage.com/')
                // navigate(`/${facilityData[1]}`)
                if (isValidPromoCode(data?.text)) {
                    setScanResult(data?.text)
                    setIsScanDisplay(false)
                    setIsDataRecorded(true)
                }else{
                    let qrcodeId = data?.text?.split('/').pop()
                    handleValidateTicket(qrcodeId, ticketId)
                }
                
            }
            setIsDataRecorded(true)
        } else {
            setIsDataRecorded(false)
        }
    }
    const doNothing = () => { }
    const handleError = (error) => {
        // notify(errorMessage?.somethingWentWrong)
        setIsDataRecorded(true)
        if(JSON.stringify(error + '').includes('Permission denied')) {
            notify('error', 'Please allow the Camera Permission to Scan the QR.')
        } else {
            notify('error', errorMessage?.somethingWentWrong)
        }
    }

    const sendBack = () => {
        setIsScanDisplay(false)
    }
    return (
        <div className={'zIndexHigh top-0 position-fixed bg-white h-100'}>
            <CommonQr
                isDisplayBack={true}
                handleClose={() => sendBack()}
                isParentCss={false}
                onError={handleError}
                onScan={!isDataRecorded ? handleScan : doNothing}
            />
        </div>
    )
}

ScanPromoQr.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    isFetching: PropTypes.bool,
    scanResult: PropTypes.string,
    setScanResult: PropTypes.func,
    notify: PropTypes.func,
    setIsScanDisplay: PropTypes.func,
    handleValidateTicket: PropTypes.func,
    
}

ScanPromoQr.defaulProps = {
    dispatch: noop,
    loader: false,
    isFetching: false,
    scanResult: '',
    setScanResult: noop,
    notify: noop,
    setIsScanDisplay: noop,
    handleValidateTicket: noop,
}

function mapStateToProps({ gatedCheckinReducer }) {
    return {
        loader: gatedCheckinReducer?.loader,
        isFetching: gatedCheckinReducer?.isFetching
    }
}
export default connect(mapStateToProps)(ScanPromoQr)
